import request from '@/utils/request'
/**
 * 用户信息
 */
export function getPetUserApi(id) {
    return request({
        url: `/cust/pet/petUser/${id}`,
        method: 'get',
    })
}

// 通用字典查询
export function getDictApi(type) {
    return request({
        url: '/cust/sys/dict-data/getByType',
        method: 'post',
        data: { type: type },
    })
}
